// Bento Box Methodology Toggle Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Find all methodology toggle buttons
  const toggleButtons = document.querySelectorAll('.bento-card__methodology-toggle');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const card = this.closest('.bento-card');
      const content = card.querySelector('.bento-card__methodology-content');
      
      if (content) {
        const isVisible = content.style.display !== 'none' && content.style.display !== '';
        
        if (isVisible) {
          content.style.display = 'none';
          this.textContent = 'View Study Details';
        } else {
          content.style.display = 'block';
          this.textContent = 'Hide Study Details';
        }
      }
    });
  });
  
  // Initially hide all methodology content
  const methodologyContents = document.querySelectorAll('.bento-card__methodology-content');
  methodologyContents.forEach(content => {
    content.style.display = 'none';
  });
});